<template>
  <div class="setup-tfa-form">
    <div class="setup-tfa-form__instructions">
      <div class="setup-tfa-form__li">
        <Badge
          label="01"
          size="medium"
          :color="{ r: 37, g: 99, b: 235, a: 1 }"
        />
        <span class="setup-tfa-form__li-title">
          Get an Authenticator app from the
          <a
            class="setup-tfa-form__ga-link"
            :href="appStoreLink"
            target="_blank"
            >App Store</a
          >
        </span>
      </div>
      <div class="setup-tfa-form__li">
        <Badge
          label="02"
          size="medium"
          :color="{ r: 37, g: 99, b: 235, a: 1 }"
        />
        <span class="setup-tfa-form__li-title"> Within the app, select <b>Set up account</b> </span>
      </div>
      <div class="setup-tfa-form__li">
        <Badge
          label="03"
          size="medium"
          :color="{ r: 37, g: 99, b: 235, a: 1 }"
        />
        <span class="setup-tfa-form__li-title"> Choose <b>Scan barcode</b> </span>
      </div>
    </div>
    <div class="setup-tfa-form__qr-code-section">
      <!-- eslint-disable vue/no-v-html -->
      <!-- we're generating the svg from the qrcode library,
      there is no user input here and no risk of XSS attack -->
      <div
        class="setup-tfa-form__qr-code"
        v-html="qrCodeSvg"
      ></div>
    </div>
    <div class="setup-tfa-form__qr-code__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SetupTfaForm',
}
</script>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import type { PropType } from 'vue'
import { toString } from 'qrcode'
import Badge from '@/uiKit/Badge/Badge.vue'

const props = // eslint-disable-next-line vue/define-props-declaration
  defineProps({
    email: {
      required: true,
      type: String,
    },
    secretKey: {
      required: true,
      type: null as unknown as PropType<string | null>,
    },
  })

const qrCodeValue = computed(() => `otpauth://totp/V7%20(${props.email})?secret=${props.secretKey}`)

const qrCodeSvg = ref('')
watch(
  qrCodeValue,
  async (value) => {
    if (value) {
      qrCodeSvg.value = await toString(value, { type: 'svg' })
    }
  },
  { immediate: true },
)

const appStoreLink = computed(
  () => 'https://apps.apple.com/us/app/google-authenticator/id388497605',
)
</script>

<style lang="scss" scoped>
@import '@/uiKit/assets/colors.global.scss';

.setup-tfa-form {
  @include col;
  row-gap: 20px;
}

.setup-tfa-form__instructions {
  width: 100%;
  @include col;
  row-gap: 16px;
}

.setup-tfa-form__li {
  @include row;
  gap: 6px;
}

.setup-tfa-form__li-title {
  @include typographyRegularBody200;
  color: var(--color-text-default);

  b {
    font-weight: bold;
  }
}

.setup-tfa-form__ga-link {
  @include typographyBoldBody200;
  color: var(--color-text-primary);
  cursor: pointer;
}

.setup-tfa-form__qr-code-section {
  width: 100%;
  @include col--center;
  background-color: var(--color-surface-secondary);
  border: 1px solid var(--color-border-default);
  padding: 16px;
  row-gap: 10px;
  border-radius: 8px;
}

.setup-tfa-form__qr-code {
  @include col--center;
  border-radius: 12px;
  width: 100px;
  height: 100px;
  overflow: hidden;
}
</style>
